// Colors
export const colors = {
  dark: '#0D022A',
  violeta_medifar: '#200762',
  celeste: '#9BC4F3',
  celeste_bebe: '#E4E8ED',
  cream: '#FBF7F4',
  text_white: '#FFFFFF',
  gray_disabled: '#949494',
  text_disabled: '#6D6D6D',
  fuscia_medifar: '#DE4789',
  rosa_medifar: '#F8AC9C',
};

// Fonts
export const fonts = {
  primary: 'Poppins',
  secondary: 'Poppins',
  userTest: 'Poppins',
};

// Font Weights
export const weights = {
  400: '400',
  500: '500',
  600: '600',
  700: '700',
};

// Breakpoints
export const breakpoints = {
  small: '768',
  medium: '1024',
  large: '1200',
  extraLarge: '1440',
  wide: '2000',
};

// Escala de espaciado en múltiplos de 4px.
export const spacing = {
  xxs: '4px',
  xs: '8px',
  sm: '12px',
  md: '16px',
  lg: '24px',
  xl: '32px',
  xxl: '40px',
  section: '64px',
  sectionLg: '80px',
  sectionXl: '120px',
};

export const radii = {
  sm: '8px',
  md: '12px',
  lg: '16px',
  xl: '24px',
  xxl: '32px',
  pill: '100px',
  circle: '50%',
  sectionTop: '40px 40px 0 0',
};

// Sombras tintadas con el violeta de marca, no negro puro.
export const shadows = {
  sm: '0 2px 8px rgba(32, 7, 98, 0.06)',
  md: '0 8px 20px rgba(32, 7, 98, 0.1)',
  lg: '0 16px 40px rgba(32, 7, 98, 0.14)',
};

export const transitions = {
  fast: '0.2s ease',
  base: '0.3s ease',
  slow: '0.6s ease',
};

export const zIndices = {
  decoration: 0,
  base: 1,
  sticky: 20,
  floating: 21,
  overlay: 30,
  modal: 40,
};

export const focusRing = `
  outline: 2px solid ${colors.fuscia_medifar};
  outline-offset: 3px;
`;

/**
 * Regla fucsia que se dibuja de izquierda a derecha. Es la firma de
 * interacción del sitio: nació en el hover del navbar y se reusa en los
 * títulos de sección y en las tarjetas para que el acento se lea como un
 * sistema y no como decoración suelta.
 *
 * Se aplica sobre un ::after o un elemento propio; quien lo usa define el
 * ancho y decide cuándo pasa a scaleX(1).
 */
export const accentRule = `
  display: block;
  height: 2px;
  background-color: ${colors.fuscia_medifar};
  transform: scaleX(0);
  transform-origin: left center;
`;
